/** axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'

import router from '../router'
import qs from 'qs'
import { Message, Loading } from 'element-ui'
import {getHeader, getLocalTimestamp, randomString} from '../assets/js/globle'
// 常量
const DEVELOPMENT_URL = process.env.API_ROOT
// const DEVELOPMENT_URL = 'http://192.168.2.52:8099/'
// const DEVELOPMENT_URL = 'https://nvwanft.cc:8443/'
// const DEVELOPMENT_URL = 'http://47.108.223.165:8099/'
// const TEST_URL = 'http://47.108.223.165:8099/'
// const PRODUCTION_URL = 'https://nvwanft.cc:8443/'
const PRODUCTION_URL = process.env.API_ROOT
let loadingInstance
// 环境的切换
// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = DEVELOPMENT_URL
// } else if (process.env.NODE_ENV === 'test') {
//   axios.defaults.baseURL = TEST_URL
// } else if (process.env.NODE_ENV === 'production') {
axios.defaults.baseURL = process.env.API_ROOT
// }

console.log(process.env.API_ROOT)

// 请求超时时间
axios.defaults.timeout = 60000

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    let token = ''
    loadingInstance = Loading.service({ fullscreen: true })
    if (localStorage.getItem('token')) {
      token = localStorage.getItem('token')
    }
    token && (config.headers.Authorization = token)
    // 加密区域
    // APP_ID，NONCE，TIMESTAMP，SIGN_TYPE，SIGN
    let secretHeader = getHeader(randomString(6), getLocalTimestamp())
    config.headers.APPID = secretHeader.APP_ID
    config.headers.NONCE = secretHeader.NONCE
    config.headers.TIMESTAMP = secretHeader.TIMESTAMP
    config.headers.SIGNTYPE = secretHeader.SIGN_TYPE
    config.headers.SIGN = secretHeader.SIGN
    config.headers.Accept = 'application/json, text/plain'
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    loadingInstance.close()
    if (response.status === 200) {
      if (response.data.code === 200) {
        return Promise.resolve(response)
      } else {
        Message.closeAll()
        Message(response.data.msg)
        return Promise.reject(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    loadingInstance.close()
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // router.replace({
          //   path: '/login',
          //   query: { redirect: router.currentRoute.fullPath }
          // })
          localStorage.removeItem('token')
          localStorage.removeItem('userVO')
          Message.closeAll()

          Message('登录失效，请重新登录')
          setTimeout(() => {
            // 防止多次重定向到login
            if (router.currentRoute.fullPath.split('login').length === 1) {
              router
                .push({
                  path: '/login',
                  query: { redirect: router.currentRoute.fullPath }
                })
            }

            console.log('route')
            // .then(() => {
            //   router.go(0)
            // })
          }, 1500)

          // router.go(0)
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          // 清除token
          localStorage.removeItem('token')
          // store.commit('loginSuccess', null)
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.push({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
          }, 1000)
          break
        // 404请求不存在
        case 404:
          Message.closeAll()
          Message(error.response.data.msg || '资源不存在')
          break
        // 其他错误，直接抛出错误提示
        default:
          Message.closeAll()
          Message(error.response.data.msg || '网络连接错误')
        // Toast({
        //   message: error.response.data.message,
        //   duration: 1500,
        //   forbidClick: true
        // })
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
/**
 * form表单方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function fromSubmit (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}

export { DEVELOPMENT_URL, PRODUCTION_URL }



// WEBPACK FOOTER //
// ./src/request/http.js